// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legends_legend__1PuBD","item":"Legends_item__1H_eq","colorBox":"Legends_colorBox__3AmFm"};